<template>
  <div class="home">
    <div class="imageWithText">
      <img
        src="@/assets/LandingPage_Shopfloor.jpg"
        alt="Shopfloor"
        class="center"
      />
      <div class="textBox">
        <h2>
          Your starting point to build the future of digital manufacturing.
        </h2>
        <span class="text"
          >Whether you‘re an independent software vendor in the additive space
          or a user of our high-end systems, take advantage of the latest
          development tools and resources to build integrated solutions based on
          our open APIs.</span
        >
      </div>
    </div>
    <div class="eosApps">
      <a
        href="https://www.eos.info/en/additive-manufacturing/software-3d-printing/data-preparation-3d-printing"
      >
        <img src="@/assets/LandingPage_EOSPRINT.png" alt="EOSPRINT 2" />
      </a>
      <a
        href="https://www.eos.info/en/additive-manufacturing/software-3d-printing/connectivity-industry-40"
      >
        <img src="@/assets/LandingPage_ECC.png" alt="EOSCONNECT Core" />
      </a>
    </div>
    <span class="strong">EOS APIs</span>
    <div class="features">
      <div class="icon">
        <img
          src="@/assets/LandingPage_GettingStarted.png"
          alt="Getting started"
        />
        <!--<a href="/edn_help.html" target='_blank'>-->
        <img
          src="@/assets/LandingPage_VirtualEnv.png"
          alt="Virtual test environment"
        />
        <!--</a>-->
        <a
          href="https://player.vimeo.com/video/843855171?h=1736e73688"
          target="_blank"
        >
          <img src="@/assets/LandingPage_VideoIntro.png" alt="Video Intro" />
        </a>
      </div>
      <div class="title">
        <span>Getting started</span>
        <span>Virtual test environment</span>
        <span
          ><a
            href="https://e.video-cdn.net/share?video-id=AFdSTQifqC8VWgxh-6UkjV&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88618"
            target="_blank"
            >Video Intro</a
          ></span
        >
      </div>
      <div class="desc">
        <span>Get access to API, documentation and code samples.</span>
        <span
          >Use virtual systems like the EOS M 290 or the EOS M 400-4 to develop
          and test your software.</span
        >
        <span
          >Watch the welcome video describing the usage of this portal.</span
        >
      </div>
    </div>
    <div>
      New to EOS or you don't have a developer account yet?<br />
      Go to
      <a href="https://www.eos.info/developer" target="_blank"
        >https://www.eos.info/developer</a
      >
      or contact us edn(at)eos.info.
    </div>
    <div class="footer">
      <ul>
        <li><a href="https://www.eos.info/en/footer/imprint">Imprint</a></li>
        <li>
          <a href="https://www.eos.info/en/footer/privacy-policy"
            >Privacy Policy</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.strong {
  font-weight: 700;
}

.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .imageWithText {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    margin-top: 40px;
    justify-content: center;
    position: relative;
    text-align: center;
    font-size: 1.2rem;
    word-break: break-word;
    background-color: #333333;
    color: #d9d9d9;

    img {
      display: box;
      width: 100%;
      object-fit: cover;
      min-height: 300px;
    }
    .textBox {
      position: absolute;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      color: $white;

      h2 {
        font-size: 36px;
        font-weight: 400;
        color: $white;
      }

      .text {
        text-align: center;
        width: 480px;
      }
    }
  }

  span {
    font-size: 20px;
  }

  .eosApps {
    img {
      margin-left: 10px;
      margin-right: 10px;
      width: 100px;
    }
    font-weight: bold;
    margin-top: 30px;
    padding: 10px;
  }
  .features {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .icon {
      display: flex;
      flex-direction: row;
      min-height: 200px;
      align-items: center;
      justify-content: center;

      img {
        width: 200px;
        padding: 50px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      span {
        margin-left: 50px;
        margin-right: 50px;
        width: 100px;
      }
    }

    .desc {
      padding: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin: 20px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(226, 223, 223);
        width: 160px;
        height: 180px;
        text-align: center;

        border-radius: 7px;
        color: rgb(97, 102, 106);
        font-size: $baseTextSize;
        font-weight: 400;
        box-shadow: none;
      }
    }
  }
  .footer {
    margin-top: 30px;
    padding: 10px;
    display: flex;
    min-height: 150px;
    width: 100%;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    background: #464f59;
    color: #464f59;
    text-align: right;
    a {
      font-size: 16px;
      color: $white;
    }
  }
}
</style>
